import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterCount'
})
export class FilterCountPipe implements PipeTransform {

  transform(value: any, filter: string): number {
    if (Array.isArray(value)) {
      if (value?.length > 0) {
        return value.filter((n: any) => n.type === filter).length;
      }
    }
    return 0
  }

}
